(function () {
    'use strict';

    var btnMoveUp;

    init();

    /**
     * Инициализация
     *
     */
    function init() {
        btnMoveUp = document.querySelector('.js-btn-move-up');
        if (!btnMoveUp) {
            return;
        }

        onWindowScroll();
        onButtonMoveUpClick();
    }

    /**
     * Обработка клика по кнопке 'Наверх'
     *
     */
    function onButtonMoveUpClick() {
        btnMoveUp.addEventListener('click', function (evt) {
            if (!window.scrollToElement) {
                return;
            }
            
            evt.preventDefault();
            window.scrollToElement(document.querySelector(evt.target.hash));
        });
    }

    /**
     * Обработка событие прокрутки содержимого страницы
     *
     */
    function onWindowScroll() {
        window.addEventListener('scroll', function () {
            var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

            if (scrollY > 700) {
                btnMoveUp.style.display = 'block';
            } else {
                btnMoveUp.style.display = 'none';
            }
        });
    }

})();

